import React from 'react';
import { Outlet } from 'react-router-dom';
import { AccountAreaGuard } from '../../components/guards/AccountAreaGuard';
import { TalentPartnerHeader } from '../../components/header/header-talent-partner';

export const MainTalentPartner: React.FC = () => {
  return (
    <div>
      <AccountAreaGuard area="talent-partner">
        <Outlet />
      </AccountAreaGuard>
    </div>
  );
};
